import { ArrowRight, ShieldCheck } from "lucide-react";
import { APPS } from "@/config";

const [APP1] = APPS;

const OPTIONS = [
  ["Use committed AWS spend", "draw down existing commitments"],
  ["The standard contract", "no new-vendor onboarding"],
  ["Flexible payments", "structure that fits the budget"],
  ["Cloud credits", "applied where eligible"],
];

export default function BuyerPagePreview({ partnerName = "", logoUrl = "" }) {
  const brandName = partnerName || "Your Brand";
  const initials =
    brandName
      .split(" ")
      .map((w) => w[0])
      .slice(0, 2)
      .join("")
      .toUpperCase() || "YB";
  const slug = brandName.toLowerCase().replace(/[^a-z0-9]+/g, "") || "marketplace";

  return (
    <div
      data-testid="buyer-page-preview"
      className="overflow-hidden rounded-2xl border border-line bg-white shadow-[0_40px_90px_-50px_rgba(31,28,25,0.4)]"
    >
      <div className="flex items-center gap-3 border-b border-line bg-parchment px-4 py-3">
        <span className="flex gap-1.5">
          <span className="h-2.5 w-2.5 rounded-full bg-line" />
          <span className="h-2.5 w-2.5 rounded-full bg-line" />
          <span className="h-2.5 w-2.5 rounded-full bg-line" />
        </span>
        <span className="flex-1 truncate rounded-full border border-line bg-white px-4 py-1 font-mono text-[10px] text-inksoft">
          {partnerName ? `${slug}.yourbrand.com` : "marketplace.yourbrand.com"}/deal-options
        </span>
      </div>

      <div className="bg-paper px-6 py-8 sm:px-8">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            {logoUrl ? (
              <img
                src={logoUrl}
                alt={`${brandName} logo`}
                data-testid="buyer-partner-logo"
                className="h-8 w-8 rounded-lg border border-line bg-white object-contain"
              />
            ) : (
              <span
                data-testid="buyer-partner-monogram"
                className="flex h-8 w-8 items-center justify-center rounded-lg bg-ink font-mono text-[9px] font-semibold text-paper"
              >
                {initials}
              </span>
            )}
            <span className="font-display text-sm font-bold text-ink" data-testid="buyer-partner-name">
              {brandName}
            </span>
          </div>
          <span className="rounded-full border border-line bg-white px-3 py-1 font-mono text-[9px] uppercase tracking-[0.16em] text-inksoft">
            Buyer view
          </span>
        </div>

        <h3 className="mt-6 font-display text-xl font-extrabold tracking-tight text-ink sm:text-2xl">
          {APP1.buyerName}
        </h3>
        <p className="mt-1.5 text-xs text-inksoft sm:text-sm">
          Choose how to purchase — every option below is open to you.
        </p>

        <div className="mt-5 space-y-2.5">
          {OPTIONS.map(([t, d]) => (
            <div
              key={t}
              className="flex items-center gap-3 rounded-xl border border-line bg-white px-4 py-3"
            >
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-md bg-vermillion-tint font-semibold text-vermillion">
                ✓
              </span>
              <span className="flex-1 text-xs sm:text-sm">
                <span className="font-semibold text-ink">{t}</span>
                <span className="ml-2 hidden text-inksoft md:inline">— {d}</span>
              </span>
            </div>
          ))}
        </div>

        <div className="mt-5 flex flex-wrap gap-2.5">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-vermillion px-4 py-2 text-xs font-semibold text-white">
            Send approval emails
            <ArrowRight size={12} />
          </span>
          <span className="inline-flex items-center rounded-full border border-ink/20 px-4 py-2 text-xs font-semibold text-ink">
            Go to my private offer
          </span>
        </div>

        <p className="mt-5 flex items-center gap-1.5 font-mono text-[9px] uppercase tracking-[0.16em] text-inksoft/70">
          <ShieldCheck size={11} className="text-vermillion" />
          Powered by Transactr
        </p>
      </div>
    </div>
  );
}
